import { engagementAppGroupIdStructuralTemplateCanvasTemplatesData } from "../engagementAppGroupIdStructuralTemplateCanvasTemplatesData";
import type { AllRouteEndpoints } from "../routeTypes";
export const engagementAppGroupIdStructuralTemplateCanvasTemplateRenameCacheKeys: AllRouteEndpoints[] = [
  engagementAppGroupIdStructuralTemplateCanvasTemplatesData,
];
